import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { keyframes } from "@emotion/react";

const scroll = keyframes`
  0% { transform: translateX(0%); }
  100% { transform: translateX(-50%); }
`;

const ContentSection = () => {
  const features = [
    "Free Onboarding",
    "Zero Setup fee",
    "Free Website Widget",
    "Free QR & Link",
    "Free Green Tick Verification",
    "Free WhatsApp Business API",
  ];

  // Duplicate items for seamless scroll
  const scrollingItems = [...features, ...features];

  return (
      <Box
        sx={{
          py: 4,
          px: 2,
          bgcolor: "#fff",
          overflow: "hidden",
          color: "#333",
          maskImage: "linear-gradient(to right, transparent 0%, black 10%, black 90%, transparent 100%)",
        }}
      >
        <Box
          sx={{
            display: "flex",
            animation: `${scroll} 20s linear infinite`,
            width: "max-content",
          }}
        >
          {scrollingItems.map((text, index) => (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              spacing={1.2}
              sx={{ px: 3, flexShrink: 0 }}
            >
              <CheckCircleIcon sx={{ color: "#00C853", fontSize: 22 }} />
              <Typography
                variant="body1"
                sx={{
                  fontWeight: 500,
                  color: "#333",
                  fontSize: "1.05rem",
                }}
              >
                {text}
              </Typography>
            </Stack>
          ))}
        </Box>
      </Box>
  );
};

export default ContentSection;
